import React from "react";
import { getSftpBadgeStyles } from "../../../../pages/pharmaStpFile/table/utils/getSftpBadgeStyles";

interface AddKeyButtonCellProps {
  value: any;
  isDisabled?: boolean;
  title?: string;
  isSftp?: boolean;
  sftpStatus?: string | null;
  [key: string]: any;
}

const getSftpStyles = (sftpStatus: string | null | undefined) => {
  return getSftpBadgeStyles(sftpStatus);
};

export const AddKeyButtonCell: React.FC<AddKeyButtonCellProps> = (props) => {
  const { isDisabled = false, title, isSftp = false, sftpStatus } = props;

  const handleClick = (e: React.MouseEvent) => {
    if (isSftp) {
      // Completely prevent any interaction for SFTP badges
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      return false;
    }
    if (isDisabled) {
      e.stopPropagation();
      return;
    }
    // Click will be handled by parent table cell onClick
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    if (isSftp) {
      e.preventDefault();
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      return false;
    }
  };

  // For SFTP badge mode
  if (isSftp) {
    const { bgColor, textColor, title: sftpTitle } = getSftpStyles(sftpStatus);

    return (
      <div
        className="table-cell-badge"
        style={{
          backgroundColor: bgColor,
          color: textColor,
          cursor: "default",
        }}
        title={sftpTitle}
        onClick={handleClick}
        onMouseDown={handleMouseDown}
        onDoubleClick={handleMouseDown}
        onPointerDown={handleMouseDown}
      >
        {sftpTitle}
      </div>
    );
  }

  // Regular button mode
  return (
    <div
      className={`table-cell-badge ${isDisabled ? "opacity-50" : ""}`}
      style={{
        color: "#FFFFFF",
        backgroundColor: "#000000",
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
      title={title}
      onClick={handleClick}
    >
      {title}
    </div>
  );
};

export default AddKeyButtonCell;
